import { SetupAppointment as UseCaseReduxSetupAppointment } from '~/domain/usecases/appointment/redux';
import { ReduxSetupAppointment } from '~/data/store/reducer/appointment/usecases/ReduxSetupAppointment';

/**
 * send request via REDUX.
 */
export const makeReduxSetupAppointment = (): UseCaseReduxSetupAppointment =>
  new ReduxSetupAppointment();
